import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingFlux3VideoAiGeneratorConfig } from '@/data/landingConfig/landingFlux3VideoAiGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_Flux3VideoAiGenerator } from './schemaObject';

interface Props {}
const Flux3VideoAiGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_Flux3VideoAiGenerator} />
			<LandingTemplate
				data={landingFlux3VideoAiGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTextToVideoV2()}
			/>
		</>
	);
};

export default Flux3VideoAiGenerator;
